import Http from './http';
import { colleagueCacheTTL } from 'Config';
import store from 'store';

class WFColleaguesService {
    constructor() {
        this.colleagues = null;
        // var intervalID = setInterval(()=>{
        //     this.resetCache()
        // }, colleagueCacheTTL);
    }

    resetCache(){
        this.colleagues = null;
        store.set('wfColleagues', false);
        this.getColleagues();
    }

    getColleagues() {
        return new Promise((resolve, reject) => {
            // if (store.get('wfColleagues', false)){
            //     this.colleagues = store.get('wfColleagues');
            // }
            if (this.colleagues) resolve(this.colleagues);
            else {
                Http.get('/colleagues/wf/').then(resp => {
                    this.colleagues = resp.data;
                    store.set('wfColleagues', this.colleagues);
                    resolve(resp.data);
                });
            }
        })
    }
}

export default new WFColleaguesService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/wfColleagues.js